export default __webpack_public_path__ + "static/media/ico_csv.96fb213b.svg";